<template>
  <div class="relative">
    <video
      ref="videoRef"
      :poster="videoData.placeholderImageUrl"
      controls
      class="w-full h-auto aspect-video"
      :preload="isMobile ? 'metadata' : 'auto'"
    >
      <source
        :src="videoData[isMobile ? 'mobile' : 'desktop'].url"
        type="video/mp4"
      />
    </video>
  </div>
</template>

<script setup lang="ts">
import { mq_breakpointIsMobile } from '@/injectionSymbols';
import type { BasicVideoData } from './type';

const isMobile = inject(mq_breakpointIsMobile);
const videoRef = ref(null);

defineProps({
  videoData: {
    type: Object as PropType<BasicVideoData>,
    required: true,
  },
});
</script>

<style scoped lang="postcss"></style>
